import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TargetingFilterItem = _resolveComponent("TargetingFilterItem");
  const _component_SelectedSection = _resolveComponent("SelectedSection");
  const _component_ListSection = _resolveComponent("ListSection");
  const _component_WrapWithDropdownBody = _resolveComponent("WrapWithDropdownBody");
  return _openBlock(), _createBlock(_component_WrapWithDropdownBody, {
    isModified: $props.isModified,
    actionsText: $props.pendingChanges,
    name: $props.title,
    keyword: $props.keyword,
    searchPlaceholder: "Search keywords...",
    onHidden: _cache[4] || (_cache[4] = $event => _ctx.$emit('hidden')),
    onDiscard: _cache[5] || (_cache[5] = $event => _ctx.$emit('discard')),
    onApply: _cache[6] || (_cache[6] = $event => _ctx.$emit('apply')),
    onCloseDropdown: _cache[7] || (_cache[7] = $event => _ctx.$emit('closeDropdown')),
    onSearch: _cache[8] || (_cache[8] = val => _ctx.$emit('search', val)),
    onRestoreSearch: _cache[9] || (_cache[9] = $event => _ctx.$emit('restoreSearch'))
  }, {
    selected: _withCtx(() => [_createVNode(_component_SelectedSection, {
      title: "Keywords",
      count: $props.selected.length,
      isModified: $props.isModified,
      heightFromTop: "118px",
      onClear: _cache[0] || (_cache[0] = $event => {
        _ctx.$emit('clear');
      }),
      onApply: _cache[1] || (_cache[1] = $event => _ctx.$emit('apply')),
      onCloseDropdown: _cache[2] || (_cache[2] = $event => _ctx.$emit('closeDropdown'))
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.selected, ({
        targeting,
        keyword_id_list,
        id
      }) => {
        return _openBlock(), _createBlock(_component_TargetingFilterItem, {
          key: id,
          targeting: targeting,
          id: id,
          query: $props.keyword,
          selected: "",
          onDeselect: $event => _ctx.$emit('deselect', {
            targeting,
            keyword_id_list,
            id
          })
        }, null, 8, ["targeting", "id", "query", "onDeselect"]);
      }), 128))]),
      _: 1
    }, 8, ["count", "isModified"])]),
    list: _withCtx(() => [_createVNode(_component_ListSection, {
      title: "Keywords",
      count: $props.list.length,
      searching: $props.isSearching,
      keyword: $props.keyword,
      onSelectAll: _cache[3] || (_cache[3] = $event => _ctx.$emit('selectAll')),
      heightFromTop: "118px"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.list, ({
        targeting,
        keyword_id_list,
        id
      }) => {
        return _openBlock(), _createBlock(_component_TargetingFilterItem, {
          key: id,
          targeting: targeting,
          id: id,
          query: $props.keyword,
          onSelect: $event => _ctx.$emit('select', {
            targeting,
            keyword_id_list,
            id
          }),
          onSelectOnly: $event => _ctx.$emit('selectOnly', {
            targeting,
            keyword_id_list,
            id
          })
        }, null, 8, ["targeting", "id", "query", "onSelect", "onSelectOnly"]);
      }), 128))]),
      _: 1
    }, 8, ["count", "searching", "keyword"])]),
    _: 1
  }, 8, ["isModified", "actionsText", "name", "keyword"]);
}